<mat-toolbar color="primary">
    <button mat-icon-button (click)="sidenav.toggle()">
        <mat-icon>menu</mat-icon>
    </button>
    <div class="logo" routerLink="/dashboard">
        <h1 translate>home.title</h1>
    </div>
</mat-toolbar>

<mat-sidenav-container>
    <!-- サイドバー -->
    <mat-sidenav #sidenav [(mode)]="navmode" [(opened)]="opened">
                 <mat-nav-list>
                     <div *ngFor="let item of navItems">
                         <a mat-list-item routerLink={{item.path}} (click)="sidenav.toggle()">{{ item.name | translate }}</a>
                     </div>
                 </mat-nav-list>
    </mat-sidenav>

    <!-- サイドバー内のコンテンツ -->
    <mat-sidenav-content>
        <!-- メインコンテンツ -->
        <router-outlet></router-outlet>

        <!-- フッター -->
        <div class="footer-container">
            <div class="footer-info">
                <span routerLink="/terms" translate>footermenu.terms</span>
                <span routerLink="/privacy" translate>footermenu.privacy</span>
            </div>
            <div class="footer-title" translate>
                <mat-icon>copyright</mat-icon>
                <span>2021</span>
                home.title
            </div>
        </div>

    </mat-sidenav-content>
</mat-sidenav-container>